import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=96006072&"
import script from "./LoadMore.vue?vue&type=script&lang=ts&"
export * from "./LoadMore.vue?vue&type=script&lang=ts&"
import style0 from "./LoadMore.vue?vue&type=style&index=0&id=96006072&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports